/**
 * Creates a new, empty project object.
 *
 * A project object contains two properties: `files` and `folders`, both initialized as empty objects.
 *
 * @returns An empty project object.
 */
export const getEmptyProject = () => ({files: {}, folders: {}});
